import { render, staticRenderFns } from "./permissionRooms.vue?vue&type=template&id=6b5f3db2"
import script from "./permissionRooms.vue?vue&type=script&lang=js"
export * from "./permissionRooms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports